import React from 'react'

function Header() {
  return (
    <div className="header_container">
      <img
        src="/assets/images/logo-trello.gif"
        alt="logo"
        className="header_logo"
      />
      <img
        src="/assets/images/avatar.png"
        alt="avatar"
        className="header_avatar"
      />
    </div>
  )
}

export default Header
